"use client";
import { ToastContainer } from "react-toastify";

const ToastifyOutput = () => {
  return <ToastContainer position="bottom-right" />;
};

export default ToastifyOutput;
